import i18n from "../../../i18n/i18n";

const apiUrl = (process.env.REACT_APP_BACKEND as string) + '/api';

interface FinanceCapacityData {
  name: string;
  date: string;
  time: string;
  place: string;
  lat: number;
  lon: number;
  email: string;
  link: string;
  lang?: string;
}

export async function getNatalLink(
  data: FinanceCapacityData,
  kind: 'telegram' | 'web'
) {
  let url = `${apiUrl}/natal-calc-telegram`;
  const payload = {...data, lang: i18n.language}

  const result = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
    credentials: 'include',
  }).then((response) => response.json());
 
  const tgLink = result?.data?.telegramLink
  
  if (!tgLink){
    alert('Ошибка при обращении к серверу');
    console.log('Ошибка ', result);
    return 0;
  } 

  if (kind === 'telegram') return tgLink 
  const id = tgLink.match(/id_fy=(\d+)/)?.[1]

  return id ? `https://indi.chronos.mg/natal/${id}` : 0;
}

export const getPartnerToken = (partner: string) => {
  if(partner === 'lab_landing') return partner;
  return 'our_chronos_token';
}
